import FriendNew from './views/friendNew';

export default [
    {
        path: '/friends/new/:friendToken',
        name: 'FriendNew',
        component: FriendNew,
    },
];